<template>
  <div>
    <b-modal
      @hidden="$emit('close')"
      hide-footer
      class="text-right"
      title="وضعیت اطلاعات احراز هویتی کاربر"
      id="user-verify-modal-status"
    >
      <template v-if="initLoading">
        <BaseLoading/>
      </template>

      <template v-else>
        <div>
          <b-container fluid>
            <b-row
              v-for="(item,i) in userApprovalData"
              :key="i"
              class="mb-3">
              <b-col sm="6">
                <label for="address">
                  {{ item.label }}
                  <b-badge v-if="item.state.status" variant="success">
                    تایید شده
                  </b-badge>
                  <b-badge v-else variant="danger">
                    رد شده
                  </b-badge>
                </label>
              </b-col>
              <b-col sm="6" class="d-flex align-items-center justify-content-center">
                <base-button
                  v-if="adminsAccessOnly"
                  :loading="item.state.loading"
                  @click="updateApprovalUserData(item)"
                  :type="!item.state.status ? 'success' : 'danger'">
                  {{ item.state.label }}
                </base-button>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <b-button
            class="mt-3"
            variant="outline-danger"
            @click="$bvModal.hide('user-verify-modal-status')"
          >
            بستن
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {BaseButton} from "@/components";
import {getAccountVerification, updateAccountApproval} from "@/httpservices/PersonalInfo";
import Swal from "sweetalert2";
import BaseLoading from "@/components/BaseLoading";
import store from "@/store";

export default {
  name: "ModalUserVerifyStatus",

  data() {
    return {
      initLoading: true,
      userApprovalData: [
        {
          label: 'ایمیل',
          state: {
            label: "رد کردن",
            status: false,
            step: "Email",
            value: "",
            loading: false,
          },
        },
        {
          label: 'اطلاعات اولیه',
          state: {
            label: "رد کردن",
            status: false,
            step: "PersonalInfo",
            value: "",
            loading: false,
          },
        },
        {
          label: 'شماره اصلی',
          state: {
            label: "رد کردن",
            status: false,
            step: "MainNumberOwnership",
            value: "",
            loading: false,
          },
        },
        {
          label: 'شماره دوم',
          state: {
            label: "رد کردن",
            status: false,
            step: "SecondNumberOwnership",
            value: "",
            loading: false,
          },
        },
        {
          label: 'مدارک',
          state: {
            label: "رد کردن",
            status: false,
            step: "Documents",
            value: "",
            loading: false,
          },
        },
        {
          label: ' تلفن ثابت',
          state: {
            label: "رد کردن",
            status: false,
            step: "Landline",
            value: "",
            loading: false,
          },
        },
        {
          label: ' آدرس و کد پستی',
          state: {
            label: "رد کردن",
            status: false,
            step: "AddressPostalCode",
            value: "",
            loading: false,
          },
        },
      ],
    }
  },

  components: {
    BaseLoading,
    BaseButton,
  },

  computed: {
    adminsAccessOnly() {
      return Boolean(
        store.getters['isSuperAdmin'] ||
        store.getters['isManagerAdmin'] ||
        store.getters['isApprovingManager']
      );
    }
  },


  mounted() {
    this.$nextTick(() => {
      this.$bvModal.show('user-verify-modal-status');
      this.getUserVerifications();
    });
  },

  methods: {
    async updateApprovalUserData(item) {
      item.state.loading = true;
      try {
        const accountId = this.$route.params.id;
        await updateAccountApproval(accountId, {
          step: item.state.step,
          state: item.state.value !== 'Approved' ? 'Approved' : 'Rejected',
        });
        await Swal.fire({
          title: "با موفقیت انجام شد.",
          icon: "success",
          confirmButtonText: "باشه"
        });

        if (!this.userApprovalData[2].state.status) {
          await Swal.fire({
            title: "لطفا شماره اصلی کاربر رو هم تایید کنید",
            icon: "warning",
            confirmButtonText: "باشه"
          });
        }

        await this.getUserVerifications();
      } catch (e) {
        console.log(e)
      }
      item.state.loading = false;
    },

    async getUserVerifications() {
      this.initLoading = true;
      try {
        const res = (await getAccountVerification(this.$route.params.id)).data;
        this.userApprovalData = this.userApprovalData.map(item => {
          const findItem = res.find(i => i.step === item.state.step) || {};
          const state = {
            label: findItem.state === "Approved" ? 'رد کردن' : 'تایید کردن',
            status: findItem.state === "Approved",
            value: findItem.state,
            loading: false,
          };
          console.log({state})
          return {
            ...item,
            state: {
              ...item.state,
              ...state
            }
          }
        })
      } catch (e) {
        console.log(e)
      }
      this.initLoading = false;
    }
  }
}
</script>

<style scoped>

</style>
